<template>
    <div>
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
    </div>
</template>

<script>
export default {
    name: "FlashError",
    props: {},
    data() {
        return {}
    },
    methods: {
        flashError(error) {
            console.error(error.response);
            this.flashMessage.error({
                title: '',
                message: error.response.data.message || error.response.data || 'Error',
                time: 3000,
                blockClass: 'flash-message error'
            });
        },
    }
}

</script>

<style scoped>
</style>
